import { render, staticRenderFns } from "./StepsTabs.vue?vue&type=template&id=698675ca&scoped=true&"
import script from "./StepsTabs.vue?vue&type=script&lang=js&"
export * from "./StepsTabs.vue?vue&type=script&lang=js&"
import style0 from "./StepsTabs.vue?vue&type=style&index=0&id=698675ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698675ca",
  null
  
)

export default component.exports